import type { FriedDropzoneV2Localization } from '@getaccept/fried-tofu';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';

interface DropzoneLocalization {
  drag_and_drop_or: string;
  browse_to_choose_a_file: string;
  recommended_file_types: string;
  max_file_size: string;
  invalid_file: string;
  chosen_file: string;
}

export default class Translations {
  static dropzoneLocalization = (): DropzoneLocalization => ({
    drag_and_drop_or: t('drag-and-drop-or').toString(),
    browse_to_choose_a_file: t('browse-to-choose-a-file').toString(),
    recommended_file_types: t('recommended-file-types').toString(),
    max_file_size: t('max-file-size').toString(),
    invalid_file: t('invalid-file').toString(),
    chosen_file: t('chosen-file').toString(),
  });

  static dropzoneV2Localization = ({
    maxNumberOfFiles,
    maxFileSize,
    acceptedFileTypes,
  }: {
    maxNumberOfFiles: number;
    maxFileSize: number;
    acceptedFileTypes: string | string[];
  }): FriedDropzoneV2Localization => ({
    main: {
      drag_and_drop_singular: t('fried_dropzone_drag_and_drop_singular'),
      drag_and_drop_plural: t('fried_dropzone_drag_and_drop_plural'),
      browse: t('fried_dropzone_browse'),
      file_types_instructions: t('fried_dropzone_upload_instructions_file_types', {
        fileTypes: Array.isArray(acceptedFileTypes)
          ? acceptedFileTypes.join(',')
          : acceptedFileTypes,
      }),
      max_size_instructions: t('fried_dropzone_upload_instructions_max_file_size', {
        maxSize: maxFileSize,
      }),
    },
    file_input: {
      title: t('fried_dropzone_file_input_title', {
        fileTypes: Array.isArray(acceptedFileTypes)
          ? acceptedFileTypes.join(',')
          : acceptedFileTypes,
        maxSize: maxFileSize,
      }),
    },
    errors: {
      single: {
        invalid_file: t('fried_dropzone_single_invalid_file'),
        not_accepted: t('fried_dropzone_single_not_accepted', {
          fileTypes: Array.isArray(acceptedFileTypes)
            ? acceptedFileTypes.join(',')
            : acceptedFileTypes,
        }),
        too_large: t('fried_dropzone_single_too_large', {
          maxSize: maxFileSize,
        }),
        no_extension: t('fried_dropzone_single_no_extension'),
        resolution_too_high: t('fried_dropzone_single_resolution_too_high'),
      },
      multiple: {
        not_accepted: t('fried_dropzone_multiple_not_accepted', {
          fileTypes: Array.isArray(acceptedFileTypes)
            ? acceptedFileTypes.join(',')
            : acceptedFileTypes,
        }),
        too_large: t('fried_dropzone_multiple_too_large', {
          maxSize: maxFileSize,
        }),
        no_extension: t('fried_dropzone_multiple_no_extension'),
        upload_failed: t('fried_dropzone_multiple_upload_failed'),
        resolution_too_high: t('fried_dropzone_multiple_resolution_too_high'),
        too_many_files: t('fried_dropzone_multiple_too_many_files', {
          maxFiles: maxNumberOfFiles,
        }),
      },
    },
  });
}
